import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery7 = () => (
    <Table tableData={TABLES.QUERY_7} theme="horizontal" />
);
